import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LastDealsProvider } from '@prlw/core/deals/last-deals.provider';

@Component({
  selector: 'prlw-last-deals-table-header-row',
  templateUrl: './last-deals-table-header-row.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastDealsTableHeaderRowContainer {
  @Input() public showContent: boolean | null = true;

  constructor(private readonly lastDealsProvider: LastDealsProvider) {}

  columns$ = this.lastDealsProvider.columns$;
  gridSize$ = this.lastDealsProvider.gridSize$;
}
